import { render, staticRenderFns } from "./wheels.vue?vue&type=template&id=0921f336&scoped=true"
import script from "./wheels.vue?vue&type=script&lang=js"
export * from "./wheels.vue?vue&type=script&lang=js"
import style0 from "./wheels.vue?vue&type=style&index=0&id=0921f336&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0921f336",
  null
  
)

export default component.exports